import en_US from './en_US.json';
import zh_CN from './zh_CH.json';

const locales = {
    'en_US': en_US,
    'zh_CN': zh_CN,
};
 
export default locales